<div class="blur-content">
  <div class="page-container" style="background-color: #f2f8fa !important">
    <app-sidebar-menu [selected]="selected" [isAdmin]="true"></app-sidebar-menu>
    <div class="main-content">
      <app-header></app-header>
      <div class="main-content-inner">
        <div class="row mt-5">
          <div class="col-12" style="padding-right: 0 !important; margin-right: 0 !important">
            <div class="card">
              <div class="card-body">
                <h4 class="mb-4">Assign Training</h4>
                <div *ngIf="successMessage" class="alert alert-success">{{ successMessage }}</div>
                <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>

                <div class="row">
                  <div class="col" *ngFor="let dd of dropdowns">
                    <div class="dropdown-container">
                      <label class="dropdown-label">{{ dd.label }}<span *ngIf="dd.required"> *</span></label>
                      <div class="dropdown-trigger" (click)="toggleDropdown(dd)">
                        <span class="dropdown-text">{{ getLabel(dd) }}</span>
                        <i class="fa fa-chevron-down dropdown-arrow" [class.open]="dd.open"></i>
                      </div>
                      <div class="dropdown-panel" *ngIf="dd.open">
                        <input type="text" class="dropdown-search" placeholder="Search..." [(ngModel)]="dd.search">
                        <div class="dropdown-list">
                          <div *ngIf="dd.loading" class="dropdown-status">
                            <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                          </div>
                          <div *ngFor="let item of filteredItems(dd)" class="dropdown-option" (click)="toggleItem(dd, item)">
                            <input *ngIf="dd.multi" type="checkbox" [checked]="isItemSelected(dd, item)" (click)="$event.stopImmediatePropagation(); toggleItem(dd, item)">
                            <span [class.selected-item]="!dd.multi && isItemSelected(dd, item)">{{ dd.displayFn(item) }}</span>
                          </div>
                          <div *ngIf="!dd.loading && filteredItems(dd).length === 0" class="dropdown-status">No results found</div>
                        </div>
                      </div>
                      <button *ngIf="dd.key === 'trainings'" class="btn btn-success btn-sm btn-add mt-2" (click)="addToTable()" [disabled]="isSubmitting">
                        <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm mr-1" role="status"></span>
                        {{ isSubmitting ? 'Adding...' : '+ Add' }}
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Assigned Training Table -->
                <div class="mt-4">
                  <div *ngIf="isLoadingTable" class="text-center py-4">
                    <div class="spinner-border text-primary" role="status"></div>
                  </div>
                  <div class="table-responsive" *ngIf="!isLoadingTable && assignedRows.length > 0">
                    <table class="table table-bordered table-sm">
                      <thead class="thead-light">
                        <tr>
                          <th>Training</th>
                          <th>Employer</th>
                          <th>Program</th>
                          <th>Client</th>
                          <th>Job</th>
                          <th>Start Date</th>
                          <th>End Date</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let row of assignedRows">
                          <td>{{ row.trainingFileName || '-' }}</td>
                          <td>{{ row.employer || '-' }}</td>
                          <td>{{ row.program || '-' }}</td>
                          <td>{{ row.clientName || '-' }}</td>
                          <td>{{ row.job || '-' }}</td>
                          <td>{{ row.startDate ? (row.startDate | date:'yyyy-MM-dd') : '-' }}</td>
                          <td>{{ row.endDate ? (row.endDate | date:'yyyy-MM-dd') : '-' }}</td>
                          <td class="text-nowrap">
                            <button class="btn btn-sm btn-primary mr-1" (click)="editRow(row)">Edit</button>
                            <button class="btn btn-sm btn-danger" (click)="confirmDelete(row)">Delete</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <!-- Pagination -->
                    <div class="pagination-container">
                      <ngb-pagination
                        [collectionSize]="totalRecords"
                        [(page)]="pageNumber"
                        [pageSize]="pageSize"
                        [maxSize]="4"
                        [boundaryLinks]="true"
                        [rotate]="true"
                        (pageChange)="loadAssignedTrainings()"
                        class="paginationSet">
                      </ngb-pagination>
                      <div class="select-wrapper">
                        <select class="form-select" [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange()">
                          <option *ngFor="let opt of pageSizeOptions" [ngValue]="opt">{{ opt }} items per page</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="!isLoadingTable && assignedRows.length === 0" class="text-center text-muted py-3">
                    No training assignments found.
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Edit Modal -->
<div class="modal-backdrop" *ngIf="editingRow" (click)="cancelEdit()"></div>
<div class="edit-modal" *ngIf="editingRow">
  <div class="edit-modal-content">
    <div class="edit-modal-header">
      <h5>Edit Training Assignment</h5>
      <button class="close-btn" (click)="cancelEdit()">&times;</button>
    </div>
    <div class="edit-modal-body">
      <div *ngIf="editError" class="alert alert-danger py-2">{{ editError }}</div>
      <div class="form-group">
        <label>Training</label>
        <input type="text" class="form-control" [value]="editingRow.trainingFileName" disabled>
      </div>
      <div class="form-group">
        <label>Start Date <span class="text-danger">*</span></label>
        <input type="date" class="form-control" [(ngModel)]="editForm.startDate" [min]="today" (change)="onStartDateChange()">
      </div>
      <div class="form-group">
        <label>End Date (Optional)</label>
        <input type="date" class="form-control" [(ngModel)]="editForm.endDate" [min]="minEndDate">
      </div>
    </div>
    <div class="edit-modal-footer">
      <button class="btn btn-outline-primary mr-2" (click)="cancelEdit()" [disabled]="isSavingEdit">Close</button>
      <button class="btn btn-primary" (click)="saveEdit()" [disabled]="isSavingEdit">
        <span *ngIf="isSavingEdit" class="spinner-border spinner-border-sm mr-1" role="status"></span>
        {{ isSavingEdit ? 'Saving...' : 'Save' }}
      </button>
    </div>
  </div>
</div>

<!-- Delete Confirmation Modal -->
<div class="modal-backdrop" *ngIf="pendingDeleteRow" (click)="cancelDelete()"></div>
<div class="edit-modal" *ngIf="pendingDeleteRow">
  <div class="edit-modal-content delete-modal-content">
    <div class="delete-modal-header">
      <h5 class="font-weight-bold mb-0">Delete Training Assignment</h5>
    </div>
    <div class="delete-modal-body">
      <p class="mb-0">Are you sure you want to delete this training assignment? This action cannot be undone.</p>
    </div>
    <div class="delete-modal-footer">
      <button class="btn btn-outline-primary mr-2" (click)="cancelDelete()">Cancel</button>
      <button class="btn btn-danger" (click)="deleteRow()">Delete</button>
    </div>
  </div>
</div>
